import { LoaderFunctionArgs, Outlet } from 'react-router-dom';

import { TCustomRouteObject, THandle } from '@/shared/types/router.types';
import { GatewayFragment } from '@/shared/types/types.generated';

export const mapRouteHandle: THandle = {
  crumb: {
    label: 'map',
    localized: true,
  },
};

export const mapRoutes: TCustomRouteObject = {
  path: '/map',
  Component: () => <Outlet />,
  handle: mapRouteHandle,
  children: [
    {
      index: true,
      lazy: async () => {
        const { MapRoute } = await import('./map');
        return { Component: MapRoute };
      },
    },
    {
      path: ':gatewayId',
      lazy: async () => {
        const { MapGatewayDetailRoute } = await import('./gateway-detail');
        return { Component: MapGatewayDetailRoute };
      },
      shouldRevalidate: () => false,
      loader: async (args: LoaderFunctionArgs) => {
        const { mapGatewayDetailLoader } = await import('./gateway-detail');
        return mapGatewayDetailLoader(args);
      },
      handle: {
        crumb: {
          label: (data: GatewayFragment) => data.name,
        },
      },
    },
  ],
};
